// @ts-nocheck
import axios from "axios";
import isEqual from "lodash.isequal";

import { appTokenStorage } from "@storage/sessionStorage";

import { ENV_CONFIG } from "@configs/env";

let camExtension = null;
let settings = null;
let toyStatus = null;
const appSettings = {
	lovenseCamExtension: {
		key: 0,
		enableState: null,
		modelName: null,
		platform: null,
		label: null,
		image: null,
		link: null,
	},
};
const PLATFORM_NAME = "dreamcam";
const SETTINGS_KEY = "app_settings";
const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => error,
);

const app_token = appTokenStorage.getItem();
if (app_token) {
	axiosInstance.defaults.headers.common["X-AUTH-TOKEN"] = app_token;
}

const getObjectDiff = (obj1, obj2) => {
	const diff = Object.keys(obj1).reduce((result, key) => {
		if (!obj2.hasOwnProperty(key)) {
			result.push(key);
		} else if (isEqual(obj1[key], obj2[key])) {
			const resultKeyIndex = result.indexOf(key);
			result.splice(resultKeyIndex, 1);
		}
		return result;
	}, Object.keys(obj2));

	return diff.length > 0 ? true : false;
};

const sendlovenseData = async (data) => {
	await axiosInstance
		.post(`${ENV_CONFIG.BASE_API_UTL}models/devices/lovense/settings`, { ...data })
		.then(() => {})
		.catch((e) => {
			console.error(e);
		});
};

export const Lovense = {
	init(modelName) {
		camExtension = new window.CamExtension(PLATFORM_NAME, modelName);
		appSettings.lovenseCamExtension = {
			key: 0,
			enableState: camExtension?.enableState,
			modelName: camExtension?.modelName,
			platform: camExtension?.platform,
			label: "Please enable lovense extension",
			image: null,
			link: null,
		};
		window.localStorage.setItem(SETTINGS_KEY, JSON.stringify(appSettings));
		window.dispatchEvent(new Event("storage"));

		camExtension.on("ready", async function () {
			appSettings.lovenseCamExtension = {
				key: 0,
				enableState: camExtension?.enableState,
				modelName: camExtension?.modelName,
				platform: camExtension?.platform,
				label: "Please enable lovense extension",
				image: null,
				link: null,
			};
			window.dispatchEvent(new Event("storage"));
			settings = await camExtension.getSettings();
			toyStatus = await camExtension.getToyStatus();
			sendlovenseData(settings);
		});
		camExtension.on("settingsChange", (data) => {
			if (settings && getObjectDiff(settings, data)) {
				settings = data;
				sendlovenseData(settings);
			}
		});
		camExtension.on("toyStatusChange", async (data) => {
			if (toyStatus && getObjectDiff(toyStatus, data)) {
				toyStatus = data;
				settings = await camExtension.getSettings();
			}
		});
		camExtension.on("tipQueueChange", (data) => {
			// console.log("data from tipQueueChange",data)
		});
	},
	receiveTip(amount, nickname) {
		if (camExtension) {
			camExtension.receiveTip(amount, nickname);
		}
	},
};
